import store from "../store";
import Constants from "../config/constants";
import {
serviceCreateSubcategory,
  serviceGetSubcategory,
  serviceUpdateSubcategory,
} from "../services/Subcategory.service";

export const FETCH_INIT = "FETCH_INIT_SUBCATEGORY";
export const FETCHED = "FETCHED_SUBCATEGORY";
export const FETCHED_FAIL = "FETCHED_FAIL_SUBCATEGORY";
export const FETCHED_FILTER = "FETCHED_FILTER_SUBCATEGORY";
export const FETCH_NEXT = "FETCH_NEXT_SUBCATEGORY";
export const FILTER = "FILTER_SUBCATEGORY";
export const RESET_FILTER = "RESET_FILTER_SUBCATEGORY";
export const SET_SORTING = "SET_SORTING_SUBCATEGORY";
export const SET_FILTER = "SET_FILTER_SUBCATEGORY";
export const SET_PAGE = "SET_PAGE_SUBCATEGORY";
export const CHANGE_PAGE = "CHANGE_PAGE_SUBCATEGORY";
export const CHANGE_STATUS = "CHANGE_STATE_SUBCATEGORY";
export const SET_SERVER_PAGE = "SET_SERVER_PAGE_SUBCATEGORY";
export const CREATE_DATA = "CREATE_SUBCATEGORY";
export const UPDATE_DATA = "UPDATE_SUBCATEGORY";
export const DELETE_ITEM = "DELETE_SUBCATEGORY";
export const UPDATE_SUBCATEGORY_ID="UPDATE_SUBCATEGORY_ID"

export function actionFetchSubcategory(
  index = 1,
  sorting = {},
  filter = {},
  shouldReset = false
) {
  const request = serviceGetSubcategory({
    index,
    row: sorting.row,
    order: sorting.order,
    ...filter,
  }); // GetSUBCATEGORY
  return (dispatch) => {
    if (shouldReset) {
      dispatch({
        type: CHANGE_PAGE,
        payload: 1,
      });
    }
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: SET_FILTER, payload: filter });
      dispatch({ type: SET_SORTING, payload: sorting });
      if (!data.error) {
        dispatch({ type: FETCHED, payload: { data: data.data, page: index } });
        dispatch({ type: SET_SERVER_PAGE, payload: index });
        if (index == 1) {
          dispatch({ type: CHANGE_PAGE, payload: index - 1 });
        }
      } else {
        dispatch({ type: FETCHED_FAIL, payload: null });
      }
    });
  };
}

export function actionCreateSubcategory(data) {
  const request = serviceCreateSubcategory(data);
  return (dispatch) => {
    request.then((data) => {
      if (!data.error) {
        dispatch({ type: CREATE_DATA, payload: data.data });
      }
    });
  };
}

export function actionUpdateSubcategory(data) {
  const request = serviceUpdateSubcategory(data);
  return (dispatch) => {
    request.then((data) => {
      if (!data.error) {
        dispatch({ type: UPDATE_DATA, payload: data.data });
      }
    });
  };
}

// export function actionDeleteSUBCATEGORY(id) {
//   const request = serviceDeleteSUBCATEGORY({ id: id });
//   return (dispatch) => {
//     dispatch({ type: DELETE_ITEM, payload: id });
//   };
// }

export function actionChangePageSUBCATEGORY(page) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PAGE, payload: page });
  };
}

export function actionFilterSUBCATEGORY(value) {
  const request = null; ////serviceFetchProviderRequests(value);
  return (dispatch) => {
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: FILTER, payload: data });
      dispatch({ type: FETCHED, payload: null });
    });
  };
}

export function actionChangeStatusSUBCATEGORY(id, status) {
  //const request = serviceUpdateSUBCATEGORY({ id: params.id, status: params.type});
  return (dispatch) => {
    dispatch({ type: CHANGE_STATUS, payload: { id, status } });
  };
}

export function actionResetFilterSUBCATEGORY() {
  return {
    type: RESET_FILTER,
    payload: null,
  };
}

export function actionSetPageSubcategory(page) {
  const stateData = store.getState().subcategory;
  const currentPage = stateData.currentPage;
  const totalLength = stateData.all.length;
  const sortingData = stateData.sorting_data;
  const query = stateData.query;
  const queryData = stateData.query_data;
  const serverPage = stateData.serverPage;

  if (totalLength <= (page + 1) * Constants.DEFAULT_PAGE_VALUE) {
    store.dispatch(
        actionFetchSubcategory(serverPage + 1, sortingData, {
        query,
        query_data: queryData,
      })
    );
  }

  console.log(currentPage, totalLength);
  return {
    type: CHANGE_PAGE,
    payload: page,
  };
}

export function actionSubcategoryId(id){
    return{
        type:UPDATE_SUBCATEGORY_ID,
        payload:id
    }
}